import { useSearchParams } from 'react-router-dom'

import { OrdersPage } from '@src/pages'
import EmbedWrapper from '@src/pages/Embed/EmbedWrapper'

const EmbedOrdersPage = () => {
    const [searchParams] = useSearchParams()

    // Parse URL parameters that are specific to this page
    // You could add Orders-specific parameters here

    return (
        <EmbedWrapper>
            <OrdersPage />
        </EmbedWrapper>
    )
}

export default EmbedOrdersPage
